import { useQuery } from '@tanstack/react-query';

import { api, queryString } from '@/lib/api';
import type { TimesheetPeriod, TimesheetResponse } from '@shared/schemas/timesheet';

/* The query behind /admin/timesheets. ROADMAP.md §10.2. */

export interface TimesheetParams {
  employeeId?: string;
  period: TimesheetPeriod;
  from?: string;
  to?: string;
}

/**
 * The same period, as a file.
 *
 * A plain URL rather than a mutation, for the reason the reports engine gives:
 * a download is a navigation, and `<a download>` is what stops the browser
 * rendering a CSV as text in a tab. The cookie goes with it, so the endpoint is
 * guarded exactly like every other admin route.
 */
export function timesheetExportUrl(params: TimesheetParams): string {
  return `/api/admin/timesheets/export${queryString({ ...params })}`;
}

export function useTimesheet(params: TimesheetParams) {
  return useQuery({
    queryKey: ['admin', 'timesheets', params],
    queryFn: () => api.get<TimesheetResponse>(`/api/admin/timesheets${queryString({ ...params })}`),
    // Keeps the previous period on screen while the next loads, so switching
    // filters does not collapse the page to a skeleton every time.
    placeholderData: (previous) => previous,
  });
}
